{
  "name": "@openstreetmap/id",
  "version": "2.40.0",
  "description": "A friendly editor for OpenStreetMap",
  "main": "dist/iD.min.js",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/openstreetmap/iD.git"
  },
  "homepage": "https://github.com/openstreetmap/iD",
  "bugs": "https://github.com/openstreetmap/iD/issues",
  "keywords": [
    "editor",
    "openstreetmap"
  ],
  "license": "ISC",
  "type": "module",
  "scripts": {
    "all": "run-s clean build dist",
    "build": "run-s build:css build:data build:js",
    "build:css": "node scripts/build_css.js",
    "build:data": "shx mkdir -p dist/data && node scripts/build_data.js",
    "build:stats": "node config/esbuild.config.min.js --stats && esbuild-visualizer --metadata dist/esbuild.json --filename docs/statistics.html && shx rm dist/esbuild.json",
    "build:js": "node config/esbuild.config.js",
    "build:js:watch": "node config/esbuild.config.js --watch",
    "clean": "shx rm -f dist/esbuild.json dist/*.js dist/*.map dist/*.css dist/img/*.svg",
    "dist": "run-p dist:**",
    "dist:mapillary": "shx mkdir -p dist/mapillary-js && shx cp -R node_modules/mapillary-js/dist/* dist/mapillary-js/",
    "dist:pannellum": "shx mkdir -p dist/pannellum && shx cp -R node_modules/pannellum/build/* dist/pannellum/",
    "dist:min": "node config/esbuild.config.min.js",
    "dist:svg:iD": "svg-sprite --symbol --symbol-dest . --shape-id-generator \"iD-%s\" --symbol-sprite dist/img/iD-sprite.svg \"svg/iD-sprite/**/*.svg\"",
    "dist:svg:community": "svg-sprite --symbol --symbol-dest . --shape-id-generator \"community-%s\" --symbol-sprite dist/img/community-sprite.svg node_modules/osm-community-index/dist/img/*.svg",
    "dist:svg:fa": "svg-sprite --symbol --symbol-dest . --symbol-sprite dist/img/fa-sprite.svg svg/fontawesome/*.svg",
    "dist:svg:maki": "svg-sprite --symbol --symbol-dest . --shape-id-generator \"maki-%s\" --symbol-sprite dist/img/maki-sprite.svg node_modules/@mapbox/maki/icons/*.svg",
    "dist:svg:mapillary:signs": "svg-sprite --symbol --symbol-dest . --symbol-sprite dist/img/mapillary-sprite.svg node_modules/@rapideditor/mapillary_sprite_source/package_signs/*.svg",
    "dist:svg:mapillary:objects": "svg-sprite --symbol --symbol-dest . --symbol-sprite dist/img/mapillary-object-sprite.svg node_modules/@rapideditor/mapillary_sprite_source/package_objects/*.svg",
    "dist:svg:roentgen": "svg-sprite --shape-id-generator \"roentgen-%s\" --shape-dim-width 16 --shape-dim-height 16 --symbol --symbol-dest . --symbol-sprite dist/img/roentgen-sprite.svg node_modules/@enzet/roentgen/icons/*.svg",
    "dist:svg:temaki": "svg-sprite --symbol --symbol-dest . --shape-id-generator \"temaki-%s\" --symbol-sprite dist/img/temaki-sprite.svg node_modules/@rapideditor/temaki/icons/*.svg",
    "imagery": "node scripts/update_imagery.js",
    "lint": "eslint config scripts test/spec modules",
    "lint:fix": "eslint scripts test/spec modules --fix",
    "start": "run-s start:watch",
    "start:single-build": "run-p build:js start:server",
    "start:watch": "run-p build:js:watch start:server",
    "start:server": "node scripts/server.js",
    "test": "npm-run-all -s lint build test:typecheck test:spec",
    "test:typecheck": "tsc",
    "test:spec": "vitest --no-isolate",
    "test:once": "vitest run --no-isolate",
    "test:coverage": "vitest run --no-isolate --coverage.enabled",
    "translations": "node scripts/update_locales.js"
  },
  "dependencies": {
    "@mapbox/geojson-area": "^0.2.2",
    "@mapbox/sexagesimal": "1.2.0",
    "@mapbox/vector-tile": "^2.0.4",
    "@rapideditor/country-coder": "~5.6.0",
    "@rapideditor/location-conflation": "~2.0.0",
    "@tmcw/togeojson": "^7.1.2",
    "@turf/bbox": "^7.2.0",
    "@turf/bbox-clip": "^7.2.0",
    "abortcontroller-polyfill": "^1.7.8",
    "aes-js": "^3.1.2",
    "alif-toolkit": "^1.3.0",
    "diacritics": "1.3.0",
    "es-toolkit": "^1.45.0",
    "exifr": "^7.1.3",
    "fast-equals": "^6.0.0",
    "fast-json-stable-stringify": "2.1.0",
    "idb-keyval": "^6.2.2",
    "marked": "~18.0.0",
    "node-diff3": "~3.2.0",
    "osm-auth": "^3.1.1",
    "pannellum": "2.5.7",
    "pbf": "^4.0.1",
    "polygon-clipping": "~0.15.7",
    "rbush": "4.0.1",
    "whatwg-fetch": "^3.6.20",
    "which-polygon": "2.2.1"
  },
  "devDependencies": {
    "@actions/github-script": "github:actions/github-script#v9",
    "@enzet/roentgen": "^0.14.0",
    "@eslint/js": "^10.0.1",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-brands-svg-icons": "^7.2.0",
    "@fortawesome/free-regular-svg-icons": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@mapbox/maki": "^8.2.0",
    "@openstreetmap/editor-layer-index": "github:osmlab/editor-layer-index#gh-pages",
    "@openstreetmap/id-tagging-schema": "^6.13.4",
    "@rapideditor/mapillary_sprite_source": "^1.8.0",
    "@rapideditor/temaki": "^5.11.0",
    "@transifex/api": "^7.1.5",
    "@types/aes-js": "^3.1.4",
    "@types/chai": "^5.2.3",
    "@types/d3": "^7.4.3",
    "@types/diacritics": "^1.3.3",
    "@types/geojson": "^7946.0.16",
    "@types/happen": "^0.3.0",
    "@types/mapbox__geojson-area": "^0.2.6",
    "@types/node": "^25.0.2",
    "@types/sinon": "^21.0.0",
    "@types/sinon-chai": "^4.0.0",
    "@types/which-polygon": "^2.2.5",
    "@vitest/coverage-v8": "^4.1.4",
    "autoprefixer": "^10.4.21",
    "browserslist": "^4.27.0",
    "browserslist-to-esbuild": "^2.1.1",
    "chai": "^6.2.0",
    "chokidar": "^5.0.0",
    "cldr-core": "^48.0.0",
    "cldr-localenames-full": "^48.0.0",
    "concat-files": "^0.1.1",
    "confusing-browser-globals": "^1.0.11",
    "d3": "~7.9.0",
    "dotenv": "^17.2.3",
    "esbuild": "^0.28.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^10.0.0",
    "fake-indexeddb": "^6.2.5",
    "fetch-mock": "^11.1.1",
    "globals": "^17.3.0",
    "happen": "^0.3.2",
    "js-yaml": "^4.1.1",
    "jsdom": "^29.0.0",
    "json-stringify-pretty-compact": "^3.0.0",
    "mapillary-js": "4.1.2",
    "name-suggestion-index": "~7.0",
    "nise": "^6.1.1",
    "npm-run-all": "^4.0.0",
    "osm-community-index": "6.0.0",
    "postcss": "^8.5.6",
    "postcss-prefix-selector": "^2.1.1",
    "serve-handler": "^6.1.6",
    "shelljs": "^0.10.0",
    "shx": "^0.4.0",
    "svg-sprite": "2.0.4",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.56.0",
    "vite": "^8.0.1",
    "vitest": "^4.1.0"
  },
  "engines": {
    "node": ">=22"
  },
  "browserslist": [
    "> 0.3%, last 6 major versions, Firefox ESR, not Safari < 14.1, not iOS <= 14, not dead, maintained node versions"
  ]
}
